<template>
    <div class="banner">
        <el-carousel height="500px">
            <el-carousel-item ><img src="@/assets/home/banner1.png" alt="" class="image"></el-carousel-item>
            <el-carousel-item ><img src="@/assets/home/banner2.png" alt="" class="image"></el-carousel-item>
            <el-carousel-item ><img src="@/assets/home/banner3.png" alt="" class="image"></el-carousel-item>
        </el-carousel>
        <!-- <div class="bannerCont" >
          <img src="@/assets/home/banner.png" alt="">
          <button @click="toDetail">了解更多</button>
        </div> -->
    </div>
</template>
<script>
export default {
  name: 'Banner',
  methods: {
    toDetail () {
      this.$router.push({ name: 'WifiNetwork' })
    }
  }
}
</script>

<style scoped lang="scss">
.banner {
    width: 100%;
    margin-top: 60px;
    // height: 430px;
    // background: -webkit-linear-gradient(left,#5749e6,#2fcfda); /* Safari 5.1-6.0 */
    // background: -o-linear-gradient(left,#5749e6,#2fcfda); /* Opera 11.1-12.0 */
    // background: -moz-linear-gradient(left,#5749e6,#2fcfda); /* Firefox 3.6-15 */
    // background: linear-gradient(left,#5749e6,#2fcfda); /* 标准语法 */
    
    .image{
      cursor: pointer;
      width: 100%;
      height: auto;
    }
  }
</style>
